// extracted by mini-css-extract-plugin
export var label = "_51-1";
export var reminder = "_51-0";